module.exports = __webpack_public_path__ + "static/media/thumbs-up.b8f1c606.svg";